interface Props {
  isLoading: boolean
  message?: string
}

export const FullscreenLoader = ({ isLoading = false, message = 'LOADING...' }: Props) => (
  <>
    {isLoading && (
      <div className="fixed inset-0 z-[90] bg-background/60 backdrop-blur-sm">
        <div className="flex h-screen items-center justify-center">
          <div className="flex flex-col items-center justify-center space-y-4">
            <div className="relative">
              <div className="h-12 w-12 animate-spin rounded-full border-4 border-border border-t-primary"></div>
            </div>
            <p className="text-sm font-medium text-muted-foreground">
              {message}
            </p>
          </div>
        </div>
      </div>
    )}
  </>
)
